import { gql } from '@apollo/client'

export const FEEDBACK_TYPES_QUERY = gql`
  query feedbackTypes(
    $page: Int
    $limit: Int
    $filter: FeedbackTypeFilter
    $sortBy: FeedbackTypeSort
  ) {
    feedbackTypes(page: $page, limit: $limit, filter: $filter, sortBy: $sortBy) {
      collection {
        id
        title
        isCallback
      }
    }
  }
`
